module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/backstage-module/components/product-search-select/product-search-select.component.scss
// module id = ./src/app/modules/backstage-module/components/product-search-select/product-search-select.component.scss
// module chunks = 9